import React, { useState, useRef } from "react";

const ImageGallery = (props) => {
  let { images } = props;
  const [selectedImage, setSelectedImage] = useState(images[0]?.[0]?.filePath);
  const [zoomLevel, setZoomLevel] = useState(1); // Initialize zoom level state
  const zoomContainerRef = useRef(null); // Ref for the zoom container

  // Handle thumbnail click to update the selected image
  const handleThumbnailClick = (filePath) => {
    setSelectedImage(filePath);
  };

  // Adjust zoom level on mouse enter
  const handleMouseEnter = () => {
    setZoomLevel(1.3); // Adjust zoom level to desired value on enter
  };

  // Reset zoom level and image position on mouse leave
  const handleMouseLeave = () => {
    setZoomLevel(0.8); // Reset zoom level on leave
    if (zoomContainerRef.current) {
      zoomContainerRef.current.style.backgroundPosition = 'center'; // Reset background position
    }
  };

  // Handle mouse move to adjust the zoomed image's position
  const handleMouseMove = (e) => {
    if (!zoomContainerRef.current) return;
    const { left, top, width, height } = zoomContainerRef.current.getBoundingClientRect();
    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;
    zoomContainerRef.current.style.backgroundPosition = `${x}% ${y}%`;
  };

  return (
    <div className="image-gallery-box">
      <div
        className="gallery-preview"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onMouseMove={handleMouseMove}
        ref={zoomContainerRef}
        style={{
          backgroundImage: `url(${selectedImage})`,
          backgroundSize: `${zoomLevel * 100}%`, // Adjust based on zoom level
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          width: '100%', // Adjust as necessary
          height: '550px', // Adjust as necessary
          transition: 'background-size 0.5s ease, background-position 0.5s ease',
        }}
      />
      <div className="gallery-thumbnail">
        {images[0].map((image, index) => (
          <img
            key={index}
            src={image?.filePath}
            alt={""}
            className="img-thumbnail"
            onClick={() => handleThumbnailClick(image?.filePath)}
          />
        ))}
      </div>
    </div>
  );
};

export default ImageGallery;